// Level of role:
// System Admin > Digital Hands Admin > Digital Hands CSM > Customer Admin > Customer User.
// The smaller number, the higher level
export const PERMISSIONS = {
  READ: 'read',
  EXECUTE: 'execute',
  DELETE: 'delete',
  UPDATE: 'update',
  CREATE: 'create',
};
